module.exports = __webpack_public_path__ + "static/media/lista_ativos.02758966.png";